import { combineReducers } from 'redux';

import {
  loadingReducer, LoadingState,
  tentativoReducer, TentativoState
} from 'django-rest-react';
import { reducers_veri } from './cache';
import { toastReducer } from './toast';
// export { ToastState } from './toast';
import { loginReducer } from './login';
import { useSelector } from 'react-redux';
// export { LoginState } from './login';



const rootReducer = combineReducers({
  login: loginReducer,
  loading: loadingReducer,
  tentativi: tentativoReducer,
  toasts: toastReducer,
  // webpush: webpushReducer,
  ...reducers_veri
});



export {
  country_all, regione_all
} from './cache';

export { reducers_map } from './cache';
export type AppState = ReturnType<typeof rootReducer>;
export const useLogin = () => useSelector((state: AppState) => state.login);
export default rootReducer;
